export default {
  extraPano: null, //krpano额外配置
  configPanoInfo: {
    //全景信息
    title: '全景项目',
    content: '',
    isSelect: 0,
    view: 0,
    project_vip: 0,
  }, //pano信息 标题 介绍 优选 浏览量 作者 项目vip 用户vip
  xml: null,
  url: null, //xml 地址
  loadMusic: false, //是否加载音乐
  needAuth: false, //是否需要密码验证
  configOpenTip: null, //开场提示
  configOpenCover: null, //开场封面
  configShare: null, //二维码分享  {url:"",logo:""}
  showPanoLoading: true, //是否显示开场loading
  enableVr: true, //vr是否可用
  enableGro: true, //陀螺仪是否可用
  auther: {
    //作者信息
    nickname: '',
    is_vip: 0,
  },
  loading: {
    //自定义loading
    src: '',
  },
  comment:{
    content_state: true,
    state: true,
    type: 1
  }
};
